<lib-outlook-user-profile
  #profile
  (logoutRequested)="logout()"
>
  @if (workspaces().length > 1) {
    <div class="tw:px-2 tw:w-full">
      <div class="tw:p-2 tw:w-full tw:text-color tw:tracking-[0.88px] tw:font-semibold tw:text-[11px] tw:leading-4">
        WORKSPACE
      </div>
      @for (workspace of workspaces(); track workspace.id) {
        <button
          type="button"
          [disabled]="workspaceChanging()"
          (click)="profile.close(); selectWorkspace(workspace.id)"
          [class]="{
            'tw:bg-p-blue-100': workspace.id === selectedWorkspaceId(),
            'tw:bg-transparent': workspace.id !== selectedWorkspaceId(),
            'tw:hover:bg-p-blue-50': workspace.id !== selectedWorkspaceId(),
            'tw:mt-1': !$first,
          }"
          class="tw:duration-300 tw:transition-all tw:flex tw:w-full tw:p-2 tw:gap-2 tw:justify-between tw:items-center tw:rounded-(--p-content-border-radius) tw:border-0 tw:border-none tw:cursor-pointer tw:text-color tw:text-left"
        >
          <i
            aria-hidden="true"
            class="pi tw:shrink-0 tw:text-muted-color"
            [class]="workspaceIcon(workspace.code)"
          ></i>
          <span class="tw:flex-1 tw:min-w-0 tw:line-clamp-1 tw:[word-break:break-word]">{{ workspace.name }}</span>
          @if (workspace.id === selectedWorkspaceId()) {
            <i
              aria-hidden="true"
              class="pi pi-check tw:shrink-0 tw:text-color"
            ></i>
          }
        </button>
      }
    </div>
    <div class="tw:my-2 tw:w-full tw:border-b tw:border-bluegray-200"></div>
  }
</lib-outlook-user-profile>
